import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

export const clientGuard: CanActivateFn = () => {
  const router = inject(Router);
  const collaborateurService = inject(PreferenceService);
  return collaborateurService.isClient ? true : router.navigate([`dossiers`]);
};
